(() => {
  const layer = document.querySelector('[data-ss-flower-rain]');
  if (!layer || layer.dataset.enabled !== 'true') return;

  const config = {
    amount: Math.max(8, Number(layer.dataset.amount) || 24),
    duration: Math.max(1400, Number(layer.dataset.duration) || 2200),
    navigationDelay: Math.max(300, Number(layer.dataset.navigationDelay) || 700),
    navigation: layer.dataset.navigation === 'true',
    addToCart: layer.dataset.addToCart === 'true',
    checkout: layer.dataset.checkout === 'true',
  };

  const spritePositions = [
    ['0%', '0%'], ['33.333%', '0%'], ['66.667%', '0%'], ['100%', '0%'],
    ['0%', '50%'], ['33.333%', '50%'], ['66.667%', '50%'], ['100%', '50%'],
    ['0%', '100%'], ['33.333%', '100%'], ['66.667%', '100%'], ['100%', '100%'],
  ];

  const activeClasses = ['is-active', 'is-covering', 'is-revealing', 'is-pulsing'];
  const heartCharacters = ['\u2665', '\u2764', '\uD83D\uDDA4', '♥', '❤', '🖤'];
  let cleanupTimer = 0;
  let lastStart = 0;

  const randomBetween = (minimum, maximum) => Math.random() * (maximum - minimum) + minimum;
  const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

  function hideCenteredTransitionHeart(root) {
    if (!(root instanceof Element)) return;
    
    const candidates = [root, ...root.querySelectorAll('span, div, i, b, svg, img')];
    candidates.forEach((candidate) => {
      const isHeartText = heartCharacters.includes(candidate.textContent?.trim());
      const className = typeof candidate.className === 'string' ? candidate.className : (candidate.getAttribute('class') || '');
      const isLoaderClass = className.match(/(loader|preloader|transition-heart|loading|spinner)/i);

      if (!isHeartText && !isLoaderClass) return;

      const style = window.getComputedStyle(candidate);
      const fixedParent = candidate.closest('[style*="position: fixed"], .page-transition, .page-loader, .loading-overlay, [class*="loader"], [class*="preloader"]');
      const fixedLike = style.position === 'fixed' || Boolean(fixedParent);
      if (!fixedLike) return;

      const rectangle = candidate.getBoundingClientRect();
      const centerX = rectangle.left + rectangle.width / 2;
      const centerY = rectangle.top + rectangle.height / 2;
      const nearScreenCenter =
        Math.abs(centerX - window.innerWidth / 2) < window.innerWidth * 0.28 &&
        Math.abs(centerY - window.innerHeight / 2) < window.innerHeight * 0.28;

      if (nearScreenCenter) candidate.style.setProperty('display', 'none', 'important');
    });
  }

  const transitionHeartObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => hideCenteredTransitionHeart(node));
    });
  });
  transitionHeartObserver.observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  // Mevcut DOM üzerindeki siyah kalpleri (preloader) anında gizle
  hideCenteredTransitionHeart(document.documentElement);

  function resetCurtain() {
    window.clearTimeout(cleanupTimer);
    layer.classList.remove(...activeClasses);
    layer.replaceChildren();
  }

  function buildFlowerCurtain(mode) {
    resetCurtain();

    const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    const isMobile = viewportWidth < 750;
    const densityBoost = clamp((config.amount - 24) / 24, 0, 1);
    const columns = isMobile ? 4 + Math.round(densityBoost) : 9 + Math.round(densityBoost);
    const rows = isMobile ? 8 + Math.round(densityBoost) : 7;
    const horizontalSpacing = viewportWidth / Math.max(1, columns - 1);
    const verticalSpacing = viewportHeight / Math.max(1, rows - 1);
    const baseSize = Math.max(horizontalSpacing, verticalSpacing) * 1.68;
    const totalFlowers = columns * rows;
    const phaseDuration = clamp(config.duration * 0.48, 820, 1180);
    const pulseDuration = clamp(config.duration * 1.08, 1800, 3200);
    const fragment = document.createDocumentFragment();
    let maximumDelay = 0;

    for (let index = 0; index < totalFlowers; index += 1) {
      const row = Math.floor(index / columns);
      const column = index % columns;
      const flower = document.createElement('span');
      const sprite = spritePositions[(index * 5 + row * 3 + column) % spritePositions.length];
      const size = baseSize * randomBetween(0.96, 1.12);
      const left = column * horizontalSpacing - size * 0.5 + randomBetween(-baseSize * 0.04, baseSize * 0.04);
      const top = row * verticalSpacing - size * 0.5 + randomBetween(-baseSize * 0.035, baseSize * 0.035);
      const rowDelay = mode === 'revealing' ? row * 16 : row * 18;
      const delay = rowDelay + randomBetween(0, 24);
      const duration = mode === 'pulse' ? pulseDuration : phaseDuration * randomBetween(0.92, 1.08);
      const rotationStart = randomBetween(-38, 38);
      const rotationMiddle = randomBetween(-12, 12);
      const rotationEnd = rotationMiddle + randomBetween(220, 420) * (Math.random() > 0.5 ? 1 : -1);

      maximumDelay = Math.max(maximumDelay, delay);
      flower.className = 'ss-flower-rain__flower';
      flower.setAttribute('aria-hidden', 'true');
      flower.style.setProperty('--flower-left', `${left.toFixed(1)}px`);
      flower.style.setProperty('--flower-top', `${top.toFixed(1)}px`);
      flower.style.setProperty('--flower-size', `${size.toFixed(1)}px`);
      flower.style.setProperty('--flower-duration', `${duration.toFixed(0)}ms`);
      flower.style.setProperty('--flower-delay', `${delay.toFixed(0)}ms`);
      flower.style.setProperty('--flower-rotation-start', `${rotationStart.toFixed(0)}deg`);
      flower.style.setProperty('--flower-rotation-middle', `${rotationMiddle.toFixed(0)}deg`);
      flower.style.setProperty('--flower-rotation-end', `${rotationEnd.toFixed(0)}deg`);
      flower.style.setProperty('--flower-x', sprite[0]);
      flower.style.setProperty('--flower-y', sprite[1]);
      fragment.appendChild(flower);
    }

    layer.style.setProperty('--curtain-phase-duration', `${phaseDuration.toFixed(0)}ms`);
    layer.style.setProperty('--curtain-pulse-duration', `${pulseDuration.toFixed(0)}ms`);
    layer.appendChild(fragment);
    layer.classList.add('is-active', `is-${mode}`);

    const completeAfter = (mode === 'pulse' ? pulseDuration : phaseDuration) + maximumDelay;
    if (mode !== 'covering') {
      cleanupTimer = window.setTimeout(resetCurtain, completeAfter + 180);
    }
    return completeAfter;
  }

  function startFlowerCurtain(options = {}) {
    const now = Date.now();
    if (!options.force && now - lastStart < 350) return 0;
    lastStart = now;

    const mode = options.mode === 'covering' || options.mode === 'revealing' ? options.mode : 'pulsing';
    return buildFlowerCurtain(mode);
  }

  function rememberArrivalCurtain() {
    try {
      window.sessionStorage.setItem('ssFlowerCurtainArrival', '1');
    } catch (_error) {
      // Gizlilik modunda sessionStorage kullanılamıyorsa yalnızca kapanış perdesi çalışır.
    }
  }

  function isPlainInternalNavigation(event, anchor) {
    if (!anchor || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (anchor.hasAttribute('download') || anchor.target === '_blank' || anchor.closest('[data-no-flower-rain]')) return false;

    const rawHref = anchor.getAttribute('href') || '';
    if (!rawHref || rawHref.startsWith('#') || rawHref.startsWith('mailto:') || rawHref.startsWith('tel:') || rawHref.startsWith('javascript:')) return false;

    let destination;
    try {
      destination = new URL(anchor.href, window.location.href);
    } catch (_error) {
      return false;
    }

    return destination.origin === window.location.origin && destination.href !== window.location.href;
  }

  function isInterfaceControl(anchor) {
    if (!anchor) return false;
    return Boolean(
      anchor.matches('#cart-icon-bubble, [aria-haspopup="dialog"], [role="button"]') ||
      anchor.hasAttribute('data-modal-opener') ||
      anchor.closest('modal-opener')
    );
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (!target) return;

    const checkoutButton = target.closest('button[name="checkout"], input[name="checkout"], .cart__checkout-button');
    if (checkoutButton && config.checkout) {
      if (checkoutButton.dataset.flowerRainBypass === 'true') {
        delete checkoutButton.dataset.flowerRainBypass;
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      const coverTime = startFlowerCurtain({ force: true, mode: 'covering' });
      window.setTimeout(() => {
        checkoutButton.dataset.flowerRainBypass = 'true';
        checkoutButton.click();
      }, Math.max(config.navigationDelay, coverTime - 40));
      return;
    }

    const manualTrigger = target.closest('[data-flower-rain-trigger]');
    if (manualTrigger) startFlowerCurtain({ force: true, mode: 'pulsing' });

    const anchor = target.closest('a[href]');
    if (config.navigation && isInterfaceControl(anchor)) {
      startFlowerCurtain({ force: true, mode: 'pulsing' });
      return;
    }

    if (!config.navigation || !isPlainInternalNavigation(event, anchor)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const coverTime = startFlowerCurtain({ force: true, mode: 'covering' });
    rememberArrivalCurtain();
    window.setTimeout(() => window.location.assign(anchor.href), Math.max(config.navigationDelay, coverTime - 40));
  }, true);

  document.addEventListener('submit', (event) => {
    if (!config.addToCart) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    let actionPath = '';
    try {
      actionPath = new URL(form.action || window.location.href, window.location.href).pathname;
    } catch (_error) {
      actionPath = '';
    }

    if (actionPath.includes('/cart/add') || form.closest('product-form')) {
      startFlowerCurtain({ force: true, mode: 'pulsing' });
    }
  }, true);

  document.addEventListener('surpriz:flower-rain', (event) => {
    startFlowerCurtain({ force: true, mode: event.detail?.mode || 'pulsing' });
  });

  window.SurprizFlowerRain = {
    start: (options = {}) => startFlowerCurtain({ force: true, ...options }),
  };

  try {
    if (window.sessionStorage.getItem('ssFlowerCurtainArrival') === '1') {
      window.sessionStorage.removeItem('ssFlowerCurtainArrival');
      window.requestAnimationFrame(() => startFlowerCurtain({ force: true, mode: 'revealing' }));
    }
  } catch (_error) {
    // sessionStorage kullanılamıyorsa sayfa normal şekilde açılır.
  }

  // Bfcache (Back-Forward Cache) temizliği: Kullanıcı tarayıcıdan "Geri" tuşuna basarsa 
  // sayfa önbellekten yüklendiği için çiçekler ekranda kalıyordu. Bunu engeller.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      resetCurtain();
    }
  });
})();
